<script lang="ts" setup>
import { computed, inject, provide } from 'vue';
import { merge } from 'lodash-es';
import { defaultConfig, CONFIG_INJECTION_KEY } from '../../shared/config';
import type { Config } from '../../shared/types';

interface Props {
  config?: Config;
}

const props = withDefaults(defineProps<Props>(), {
  config: undefined,
});

const injectedConfig = inject(CONFIG_INJECTION_KEY, null);

const config = computed<Config>(() =>
  merge({}, defaultConfig, injectedConfig?.value, props.config),
);

provide(CONFIG_INJECTION_KEY, config);
</script>

<template>
  <slot />
</template>
